import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { FaGithubSquare as BrandIcon } from 'react-icons/fa';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    '&:hover': { background: '#000000' },
    background: '#1A1E22',
    borderRadius: 4,
    color: '#FFF',
    composes: [
      'flex-columns',
      'flex-center',
      'items-center',
      'p12',
      'my6',
      'is-full-width',
    ],
    transition: 'background 0.3s',
  },
  icon: {
    composes: ['mr6', 'fs16'],
  },
  label: {
    composes: ['text-left'],
    width: 75,
  },
});

const GithubButtonComponent = function GithubButtonComponent() {
  const classes = useStyles();

  const signinHandler = useCallback(() => {
    const provider = new firebase.auth.GithubAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }, []);

  return (
    <button className={classes.button} type="button" onClick={signinHandler}>
      <BrandIcon className={classes.icon} />
      <span className={classes.label}>Github</span>
    </button>
  );
};

GithubButtonComponent.displayName = 'GithubButtonComponent';

export default GithubButtonComponent;
